import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  FormLabel,
  FormControl,
  TextField,
  Typography,
  Grid2,
  Snackbar,
  Alert,
  IconButton,
  TextareaAutosize,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ButtonGroup,
  Menu, MenuItem, Divider,
  InputLabel,
  Select
} from "@mui/material";
import {
  getContentTypeForEntry,
  submitFormData,
  resetForm
} from "../../actions/entryActions";
import { usePermission } from "../authentication/permission-providor/UserPermission";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HistoryIcon from '@mui/icons-material/History';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import AceEditor from "react-ace";
import StyledTextArea from "../../themes/overrides/TextArea";
import { useNavigate, useLocation } from 'react-router-dom';
import VersionDrawer from "../../components/VersionDrawer";

// import Quill from 'quill';
import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/theme-tomorrow";
import "ace-builds/src-noconflict/mode-json";
import { getEntryForEdit, getAllEntries, updateEntryData } from "../../actions/entryActions";
import { getSpecificWorkspace } from "../../actions/workspaceAction";

import { useParams } from "react-router-dom";
import RichText from "../../components/richText/RichText";
import AddButton from "../../themes/overrides/AddButton";
import OutlinedAddButton from "../../themes/overrides/OutlinedAddButton";
import BrushImage from "../../assets/images/brush.svg"
import CloudIcon from "../../assets/images/cloud-add.svg"
import CloudIcon2 from "../../assets/images/cloud-add2.svg"
import SaveDraftIcon from "../../assets/images/simcard.svg"
import SaveDraftIcon2 from "../../assets/images/simcard2.svg"
import { BorderAll, BorderColor } from "@mui/icons-material";
import TextFieldInput from "../../themes/overrides/TextFieldInput";
import MediaUpload from "../../components/Media/MediaUpload";
import DateTimeEntry from "../../components/DateTimeEntry";
import BooleanEntry from "../../components/BooleanEntry"
import RightDrawer from "../../components/RightDrawer";
import AddReferrenceModal from "./AddReferenceModal";
import RemoveIcon from "../../components/icons/RemoveIcon";
import AddExistingEntryPopup from "../../components/AddExistingEntryPopup";
import DeleteIcon from '../../assets/images/icons/delete_icon.svg';
import editIcon from "../../assets/images/icons/edit-2-Black.svg";
import LoadingOverlay from "../../components/LoadingOverlay";
import LoadingSpinner from "../../components/icons/LoadingSpinner";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const CreateEntry = ({ contentType, onConfirm, isDrawer, editEntry, isDrawerEdit, initialFormData, isVersionPreview = false }) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { hasPermission } = usePermission();

  const formRef = useRef();
  const [formData, setFormData] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  const [isCreateMode, setIsCreateMode] = useState(false);
  const data = useSelector((state) => state.entry.entryFields);
  const entryName = useSelector((state) => state.entry.entryName);

  const { success, error, isSaved, entryData } = useSelector((state) => state.entry);
  const entrySelector = useSelector((state) => state.entry.entry) || [];
  const entry = entrySelector?.entry;
  const entries = useSelector((state) => state.entry.entries) || [];
  const currentWorkspace = useSelector((state) => state.workspace.workspaceInfo);

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [addExistingEntryPopup, setAddExistingEntryPopup] = useState({
    open: false,
    fieldId: null
  });
  const [referenceEditing, setReferenceEditing] = useState({
    isEditing: false,
    entryData: null,
    fieldId: null
  });
  const [isNestedCreate, setIsNestedCreate] = useState(isDrawer && !isDrawerEdit);
  const [isDrawerContext, setIsDrawerContext] = useState(isDrawer);
  const [richTextState, setRichTextState] = useState({
    isReady: false,
    isDataLoaded: false
  });
  const [isViewOnly, setIsViewOnly] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [loading, setLoading] = useState(true);
  const [selectedRefs, setSelectedRefs] = useState({});
  const [currentContentId, setContentId] = useState("");
  const [isEntriesFetched, setIsEntriesFetched] = useState(false);
  const [publishLoading, setPublishLoading] = useState(false);
  const [publishDraftLoading, setPublishDraftLoading] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const [errors, setErrors] = useState({});
  const [versionPanelOpen, setVersionPanelOpen] = useState(false);
  const [modifiedFields, setModifiedFields] = useState({});
  const [modifiedLocaleFields, setModifiedLocaleFields] = useState({});


  const [spaceLocales, setSpaceLocales] = useState(["en"]);
  const primaryLocale = ["en"];
  // State for dynamic fields, map by field ids+
  const [fields, setFields] = useState({});
  const { workspaceId, id } = useParams();


  const handleDropdownClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerClose = (event) => {
    setVersionPanelOpen(false);
    setAnchorEl(null);
  };

  // const handleChange = (id, value) => {
  //   setFormData((prevData) => ({ ...prevData, [id]: value }));
  // };

  // const handleChange = (id, value, condition = false) => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     ...(condition ? {
  //       data: {
  //         ...prevData.data,
  //         [id]: value
  //       }
  //     } : {})
  //   }));
  // };

  useEffect(() => {
    if (!currentWorkspace || (Array.isArray(currentWorkspace) && currentWorkspace.length === 0)) {
      dispatch(getSpecificWorkspace(workspaceId));
    }
  }, [workspaceId, currentWorkspace, dispatch]);

  useEffect(() => {
    if (currentWorkspace?.data?.locales && currentWorkspace.data.locales.length > 0) {
      setSpaceLocales(currentWorkspace.data.locales);
    }
  }, [currentWorkspace]);

  useEffect(() => {
    if (!isDrawer) {
      const pathParts = location.pathname.split('/');
      const isEdit = pathParts.includes('edit-entry');
      if (isEdit && !isDrawerEdit) {
        dispatch(getEntryForEdit(workspaceId, id));
        setIsEntriesFetched(true)
      }
    }
  }, [location.pathname, workspaceId, id, dispatch, isDrawer, isDrawerEdit]);

  useEffect(() => {
    if (!isDrawer && !isDrawerEdit) {
      const pathParts = location.pathname.split('/');
      const isEdit = pathParts.includes('edit-entry');

      if (isEdit && entry?.contentTypeId && isEntriesFetched) {
        setIsEditMode(true);
        dispatch(getContentTypeForEntry(workspaceId, entry.contentTypeId));
      }
    }
  }, [entry, location.pathname, workspaceId, dispatch, isDrawer, isEntriesFetched, isDrawerEdit]);

  useEffect(() => {
    if (isEditMode) {
      const publishStatus = isDrawerEdit
        ? editEntry?.entry?.published
        : entry?.published;
      setIsPublished(!!publishStatus);
    }
  }, [isEditMode, editEntry, entry, isDrawerEdit]);


  useEffect(() => {
    const pathParts = location.pathname.split('/');
    const isCreate = pathParts.includes('create-entry');
    if (isCreate && !contentType?.length > 0) {
      if (currentContentId) {
        console.log(currentContentId);
        dispatch(getContentTypeForEntry(workspaceId, currentContentId));
      } else {
        dispatch(getContentTypeForEntry(workspaceId, id));
      }
      setIsEditMode(false);
      setIsCreateMode(true);
      setLoading(false);
      setIsInitialized(true);
    }

  }, [location.pathname, isDrawer, dispatch, workspaceId, id]);

  const [isInitialized, setIsInitialized] = useState(isDrawer ? true : false);
  const prevEntryRef = useRef();

  useEffect(() => {
    const initializeFormData = async () => {
      if (isDrawer) {
        setIsInitialized(true);
        setLoading(false);
        return;
      }
      if (isDrawerEdit || editEntry) {
        return;
      }
      try {
        // if (!isEditMode) {
        //   setFormData({ identifier: '', references: {} });
        //   setIsInitialized(true);
        //   return;
        // }
        if (entry?.identifier !== prevEntryRef.current?.identifier && isEditMode && !isDrawer) {
          setLoading(true);
          if (entry && isEditMode && data) {
            const initialFormData = {
              identifier: entry.identifier,
              ...entry.data
            };

            // Handle localized content
            if (entrySelector.localeContent?.length > 0) {
              entrySelector.localeContent.forEach((localeData) => {
                const locale = localeData.locale;
                Object.entries(localeData).forEach(([key, value]) => {
                  if (key !== '_id' && key !== 'locale') {
                    initialFormData[key] = initialFormData[key] || {};
                    if (key.startsWith('richtext')) {
                      initialFormData[key][locale] = Array.isArray(value) ? value : [];
                    } else {
                      initialFormData[key][locale] = value;
                    }
                  }
                });
              });
            }

            // Handle references
            if (entry.references && entrySelector.references?.[0]) {
              const referencesWithEntries = {};

              Object.entries(entry.references).forEach(([fieldId, referenceIds]) => {
                referencesWithEntries[fieldId] = [];

                const formattedRefIds = referenceIds;

                formattedRefIds.forEach(refId => {
                  const foundRef = entrySelector.references[0].find(ref =>
                    ref.id === refId && ref.entry
                  );
                  if (foundRef) {
                    referencesWithEntries[fieldId].push({
                      _id: foundRef.entry._id,
                      identifier: foundRef.entry.identifier,
                      published: foundRef.entry.published,
                      contentTypeId: foundRef.entry.contentTypeId,
                      data: foundRef.entry.data || {},
                      localeData: foundRef.entry.localeData || {},
                      content_type_name: foundRef.entry.content_type_name
                    });
                  }
                });
              });

              setSelectedRefs(referencesWithEntries);
              initialFormData.references = referencesWithEntries;
            }

            console.log('INITALFORM DATA : ', initialFormData);
            prevEntryRef.current = entry;

            setFormData(initialFormData);
            setIsNestedCreate(true);
            setRichTextState({ isReady: true, isDataLoaded: true });
            setIsInitialized(true);
          } else {
            setLoading(false);
            setIsInitialized(true);
          }
        }
      } catch (error) {
        console.error('Error initializing form data:', error);
      } finally {
        setLoading(false);
      }
    };

    initializeFormData();

    // return () => {
    //   if (!isEditMode) {
    //     setFormData({});
    //     setSelectedRefs({});
    //     setIsInitialized(false);
    //     prevEntryRef.current = null;
    //   }
    // };
  }, [entry, isEditMode, isDrawer, data]);

  useEffect(() => {
    if (!contentType) {
      return () => {
        dispatch(resetForm());
        setFormData({});
        setSelectedRefs({});
        setIsInitialized(false);
      };
    }
  }, [dispatch]);

  useEffect(() => {
    if (contentType) {
      setContentId(contentType.contentType._id);
    }
  }, [location, contentType]);


  const handleArrayChange = (id, locale, index, value) => {
    setFormData(prevData => {
      const newData = { ...prevData };
      if (!newData[id]) {
        newData[id] = {};
      }
      if (!newData[id][locale]) {
        newData[id][locale] = [];
      }

      const updatedArray = [...(newData[id][locale] || [])];
      updatedArray[index] = value;
      newData[id] = {
        ...newData[id],
        [locale]: updatedArray
      };

      if (updatedArray.some(item => item && item.trim())) {
        setErrors(prev => ({
          ...prev,
          [id]: locale ? {
            ...(prev[id] || {}),
            [locale]: ''
          } : ''
        }));
      }

      return newData;
    });
  };


  const handleArrayDelete = (id, locale, indexToDelete) => {
    setFormData(prevData => {
      const newData = { ...prevData };
      if (newData[id]?.[locale]) {
        newData[id][locale] = newData[id][locale].filter((_, index) => index !== indexToDelete);
      }
      return newData;
    });
  };

  function safeParseJSON(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      // console.error("Invalid JSON string:", error);
      return null; // or handle in another way
    }
  }

  // Initialize fields for array type fields
  useEffect(() => {
    const initialFields = {};
    data?.forEach((field) => {
      if (field.type === "array") {
        initialFields[field.id] = [""]; // Initialize with one empty field for array fields
      }
    });
    setFields(initialFields);
  }, [data]);

  const openModal = (fieldId) => {
    setAddExistingEntryPopup({
      open: true,
      fieldId
    });
  };

  // const handleRefChange = (value, fieldId) => {
  //   setSelectedRef(value);
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [fieldId]: value,
  //   }));
  // };
  const [tempSelectedEntryIds, setTempSelectedEntryIds] = useState(null);

  const handleReferenceAddEntry = async (selectedEntriesIds, fieldId) => {
    try {

      // await dispatch(getAllEntries(workspaceId)); Commented this need to check if there are any errors
      const formattedIds = selectedEntriesIds;


      setTempSelectedEntryIds({
        ids: formattedIds,
        fieldId: fieldId
      });

      if (selectedEntriesIds.length > 0) {
        setErrors(prev => ({
          ...prev,
          [fieldId]: ''
        }));
      }
    } catch (error) {
      console.error('Error loading entries:', error);
    }
  };

  useEffect(() => {
    if (tempSelectedEntryIds && Array.isArray(entries)) {
      const selectedEntries = entries.filter(entry =>
        tempSelectedEntryIds.ids.includes(entry._id)
      ).map(entry => ({
        _id: entry._id,
        identifier: entry.identifier,
        published: entry.published,
        contentTypeId: entry.contentTypeId,
        data: entry.data || {},
        localeData: entry.localeData || {},
        content_type_name: entry.content_type_name,
        references: entry.references || {}
      }));

      setSelectedRefs(prev => {
        const fieldId = tempSelectedEntryIds.fieldId;
        const prevEntriesForField = prev[fieldId] || [];

        const existingIds = new Set(prevEntriesForField.map(e => e._id));
        const newEntries = selectedEntries.filter(e => !existingIds.has(e._id));

        const updatedRefs = {
          ...prev,
          [fieldId]: [...prevEntriesForField, ...newEntries]
        };

        setFormData(prevFormData => ({
          ...prevFormData,
          references: updatedRefs
        }));

        if (updatedRefs[fieldId].length > 0) {
          setErrors(prev => ({
            ...prev,
            [fieldId]: ''
          }));
        }

        return updatedRefs;
      });

      setTempSelectedEntryIds(null);
    }
  }, [tempSelectedEntryIds, entries]);

  const handleEditReference = (entry, fieldId) => {
    setReferenceEditing({
      isEditing: true,
      entryData: entry,
      fieldId: fieldId
    });
  };


  useEffect(() => {
    const initializeDrawerEntry = async () => {
      setLoading(true);
      try {
        if (isDrawer && !versionPanelOpen) {
          setIsDrawerContext(true);
          if ((isDrawerEdit && editEntry)) {
            try {
              const formattedData = {
                identifier: editEntry?.entry?.identifier || "",
                ...editEntry?.entry?.data,
              };
              console.log('ENTRY SELECTOR : ', editEntry);

              if (editEntry.localeContent?.length > 0) {
                editEntry.localeContent.forEach((localeData) => {
                  const locale = localeData.locale;
                  Object.entries(localeData).forEach(([key, value]) => {
                    if (key !== '_id' && key !== 'locale') {
                      formattedData[key] = formattedData[key] || {};
                      if (key.startsWith('richtext')) {
                        formattedData[key][locale] = Array.isArray(value) ? value : [];
                      } else {
                        formattedData[key][locale] = value;
                      }
                    }
                  });
                });
              }

              if (editEntry.entry.references && editEntry.references?.[0]) {
                const referencesWithEntries = {};

                Object.entries(editEntry.entry.references).forEach(([fieldId, referenceIds]) => {
                  referencesWithEntries[fieldId] = [];

                  const formattedRefIds = referenceIds.map(id => {
                    if (typeof id === 'string') {
                      return id;
                    }
                    return id;
                  });

                  formattedRefIds.forEach(refId => {
                    const foundRef = editEntry.references[0].find(ref =>
                      ref.id === refId && ref.entry
                    );
                    if (foundRef) {
                      referencesWithEntries[fieldId].push({
                        _id: foundRef.entry._id,
                        identifier: foundRef.entry.identifier,
                        published: foundRef.entry.published,
                        contentTypeId: foundRef.entry.contentTypeId,
                        data: foundRef.entry.data || {},
                        localeData: foundRef.entry.localeData || {},
                        content_type_name: foundRef.entry.content_type_name
                      });
                    }
                  });
                });

                setSelectedRefs(referencesWithEntries);
                //initialFormData.references = referencesWithEntries;
              }
              console.log('Formatted Data : ', formattedData);

              setFormData(formattedData);
              setRichTextState({ isReady: true, isDataLoaded: true });
              setIsEditMode(true);
              setIsInitialized(true);

            } catch (error) {
              console.error('Error initializing drawer entry:', error);
            } finally {
              setLoading(false);
            }
          } else {
            setIsNestedCreate(true);
            setRichTextState({ isReady: true, isDataLoaded: true });
            setFormData({});
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false)
      }
    }

    initializeDrawerEntry();
  }, [isDrawerEdit, editEntry]);


  useEffect(() => {
    if (Object.keys(selectedRefs).length > 0) {
      setFormData(prev => ({
        ...prev,
        references: selectedRefs
      }));
    }
  }, [selectedRefs]);

  const getContentTypeId = () => {
    if (isEditMode && entry?.contentTypeId) {
      return entry.contentTypeId;
    }
    return contentType?.contentType?._id || id;
  };


  // const removeSelectedRef = (fieldId) => {
  //   setSelectedRef(""); // Clear the selected reference display
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [fieldId]: null, // Remove the reference from formData
  //   }));
  // };

  const renderLabel = (labelText, isRequired) => (
    <FormLabel
      component="legend"
      sx={{
        color: '#555555',
        fontWeight: 400,
        fontSize: '1rem',
        '& .required': {
          color: '#d32f2f',
          marginLeft: '4px'
        }
      }}
    >
      {labelText}
      {isRequired && <span className="required">*</span>}
    </FormLabel>
  );

  const renderError = (fieldId, locale = null) => {
    const error = errors[fieldId];

    if (!error) return null;

    if (typeof error === 'object' && !Array.isArray(error)) {
      if (locale) {
        return error[locale] && (
          <Typography
            variant="caption"
            color="error"
            sx={{
              display: 'block',
              mt: 0.5,
              ml: 1
            }}
          >
            {error[locale]}
          </Typography>
        );
      } else {
        const firstError = Object.values(error)[0];
        return firstError && (
          <Typography
            variant="caption"
            color="error"
            sx={{
              display: 'block',
              mt: 0.5,
              ml: 1
            }}
          >
            This field is required
          </Typography>
        );
      }
    }

    return (
      <Typography
        variant="caption"
        color="error"
        sx={{
          display: 'block',
          mt: 0.5,
          ml: 1
        }}
      >
        {error}
      </Typography>
    );
  };

  const getFieldValue = (field, currentValue) => {
    const emptyRichText = [
      {
        type: 'paragraph',
        children: [{ text: '' }]
      }
    ];

    // For localized fields
    if (field.localizations) {
      const defaultValues = {};
      spaceLocales.forEach(locale => {
        // If current value exists for locale, use it
        if (currentValue?.[locale] !== undefined) {
          defaultValues[locale] = currentValue[locale];
        } else {
          // Fallback to default value if no current value
          if (field.type === 'richText') {
            defaultValues[locale] = field.default_value ?
              JSON.parse(JSON.stringify(field.default_value)) :
              [...emptyRichText];
          } else {
            defaultValues[locale] = field.default_value || '';
          }
        }
      });
      return defaultValues;
    }

    // For non-localized fields
    if (currentValue !== undefined && currentValue !== null) {
      return currentValue;
    }

    // Fallback to default values if no current value
    if (field.type === 'string') {
      return { en: field.default_value || '' };
    }

    if (field.type === 'richText') {
      return field.default_value ?
        { en: [...field.default_value] } :
        { en: [...emptyRichText] };
    }

    return field.default_value ?? '';
  };


  const renderInput = (field) => {
    const { id, name, type, required, localizations } = field;
    const locales = localizations ? spaceLocales : primaryLocale;

    const fieldValue = getFieldValue(field, formData[id]);

    switch (type) {
      case "number":
        return (
          <FormControl fullWidth variant="outlined" component="fieldset">
            {renderLabel(name, required)}
            <TextField
              variant="outlined"
              fullWidth
              value={
                fieldValue || ''
              }
              style={{ marginTop: "10px" }}
              onChange={(e) => handleChange(id, e.target.value)}
              onKeyPress={(e) => {
                // Allow only numbers, decimal point, and control keys
                if (!/[\d.]|\./g.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
                  e.preventDefault();
                }
                // Prevent multiple decimal points
                if (e.key === '.' && fieldValue?.includes('.')) {
                  e.preventDefault();
                }
              }}
              sx={{
                '& .MuiInputBase-input': {
                  padding: '8px',
                },
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'black',
                  color: 'black',
                },
              }}
              disabled={isVersionPreview}
            />
            {renderError(id)}
          </FormControl>
        );

      case "string":
        return (
          <FormControl fullWidth variant="outlined" component="fieldset" style={{ marginTop: "10px" }}>
            {renderLabel(name, required)}
            {(
              locales.map((locale) => (
                <Box key={`${id}-${locale}`}>
                  {field.specific_values ? (
                    <FormControl fullWidth sx={{ mt: 1, mb: 0.5 }}>
                      <InputLabel id={`${id}-${locale}-label`}
                        sx={{
                          fontSize: '16px',
                          transform: 'translate(14px, 8px) scale(1)',
                          '&.Mui-focused, &.MuiFormLabel-filled': {
                            transform: 'translate(14px, -6px) scale(0.75)',
                          },
                          color: '#7A7A7A',
                        }}
                      >({locale})</InputLabel>
                      <Select
                        labelId={`${id}-${locale}-label`}
                        value={fieldValue?.[locale] || ''}
                        onChange={(e) => handleChange(id, e.target.value, locale)}
                        disabled={isVersionPreview}
                        label={`(${locale})`}
                        size="small"
                        sx={{
                          '& .MuiInputBase-input': {
                            padding: '8px 14px',
                          },
                          '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: 'black',
                            color: 'black',
                          },
                        }}
                      >
                        {field.specific_values.map((option) => (
                          <MenuItem
                            key={option}
                            value={option}
                            sx={{
                              fontSize: '1rem',
                              minHeight: '24px',
                              padding: '6px 6px',
                            }}
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : field.variant === 'longText' ? (
                    <Box sx={{ position: 'relative', mt: 1, mb: 0.5 }}>
                      <Typography
                        sx={{
                          position: 'absolute',
                          top: -8,
                          left: 10,
                          zIndex: 1,
                          bgcolor: 'white',
                          px: 1,
                          fontSize: '16px',
                          color: '#7A7A7A',
                        }}
                      >
                        ({locale})
                      </Typography>
                      <StyledTextArea
                        value={fieldValue?.[locale] || ''}
                        onChange={(e) => handleChange(id, e.target.value, locale)}
                        sx={{
                          '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: 'black',
                            color: 'black',
                          },
                        }}
                        disabled={isVersionPreview}
                      />
                      
                    </Box>
                  ) : (
                    <TextField
                      type="text"
                      label={`(${locale})`}
                      variant="outlined"
                      fullWidth
                      value={fieldValue?.[locale] || ''}
                      style={{ marginBottom: "3px", marginTop: "10px" }}
                      onChange={(e) => handleChange(id, e.target.value, locale)}
                      sx={{
                        '& .MuiInputBase-root': {
                          paddingY: '4px',
                        },
                        '& .MuiInputBase-input': {
                          padding: '6px',
                          paddingY: '4px',
                          lineHeight: 1.5,
                        },
                        '& .MuiInputLabel-root': {
                          top: '-6px',
                          fontSize: '16px',
                          color: '#7A7A7A',
                        },
                        '& .MuiInputBase-input.Mui-disabled': {
                          WebkitTextFillColor: 'black',
                          color: 'black',
                        },
                      }}
                      disabled={isVersionPreview}
                    />
                  )}
                  {renderError(id, locale)}
                </Box>
              ))

            )}
          </FormControl>
        );

      case "richText":
        return (
          <FormControl fullWidth variant="outlined" component="fieldset">
            {renderLabel(name, required)}
            {(!richTextState.isReady && !isCreateMode && !isNestedCreate) ? (
              <LoadingOverlay />
            ) : (
              locales.map((locale) => {
                const fieldValue = getFieldValue(field, formData[field.id]);
                return (
                  <div key={`${id}-${locale}-${formData._versionKey}`}>
                    <FormLabel
                      component="legend"
                      sx={{
                        color: '#555555',
                        fontWeight: 400,
                        mt: 1,
                        fontSize: '0.85rem',
                        '& .required': {
                          color: '#d32f2f',
                        }
                      }}
                    >
                      Locale : {locale}
                    </FormLabel>
                    <RichText
                      key={`${id}-${locale}`}
                      label={`(${locale})`}
                      type="richText"
                      value={fieldValue[locale]}
                      onChange={(value) => handleChange(id, value, locale)}
                      locale={locale}
                      disabled={isVersionPreview}
                    />
                    {renderError(id, locale)}
                  </div>
                );
              })
            )}
          </FormControl>
        );
      case "media":
        return (
          <div>
            <MediaUpload
              name={renderLabel(name, required)}
              workspaceId={workspaceId}
              value={formData[field.id] || []}
              onChange={(files) => handleChange(id, files)}
            />
            {renderError(id)}
          </div>
        );

      case "dateTime":
        return (
          <div>
            <DateTimeEntry
              name={renderLabel(name, required)}
              value={fieldValue || {
                date: '',
                time: '',
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
              }}
              onChange={(value) => handleChange(id, value)}
            />
            {renderError(id)}
          </div>
        );

      case "boolean":
        return (
          <div>
            <BooleanEntry
              name={renderLabel(name, required)}
              value={fieldValue}
              onChange={(value) => handleChange(id, value)}
            />
            {renderError(id)}
          </div>
        )

      case "object":
        return (
          <FormControl fullWidth variant="outlined" component="fieldset">
            {renderLabel(name, required)}
            {field.display?.url ? (
              <iframe
                src={`${field.display.url}?data=${encodeURIComponent(JSON.stringify(fieldValue || {}))}`}
                style={{
                  width: "100%",
                  height: "500px",
                  border: "none",
                  borderRadius: "4px"
                }}
                title={field.display.appName}
                loading="lazy"
                onError={(e) => {
                  console.error("iframe loading error:", e);
                }}
              />
            ) : (
              <AceEditor
                mode="json"
                theme="tomorrow"
                value={fieldValue && (JSON.stringify(fieldValue, null, 2))}
                onChange={(value) => handleChange(id, safeParseJSON(value))}
                editorProps={{ $blockScrolling: true }}
                style={{ width: "100%", minHeight: "100px", marginTop: 6 }}
              />
            )}
            {renderError(id)}
          </FormControl>
        );
      case "array":
        return (
          <FormControl fullWidth variant="outlined" component="fieldset">
            {renderLabel(name, required)}
            {field.array_type === 'string' ? (

              locales.map((locale) => (
                <Accordion
                  key={locale}
                  defaultExpanded
                  sx={{
                    mt: 1,
                    '&:before': { display: 'none' },
                    boxShadow: 'none',
                    border: '1px solid #e0e0e0',
                    borderRadius: '4px',
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography color="primary">Locale: {locale}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {(formData[id]?.[locale] || [""]).map((value, index) => (
                      <Box
                        key={`${index}-${locale}`}
                        sx={{
                          display: 'flex',
                          gap: 1,
                          mb: 1,
                          alignItems: 'center'
                        }}
                      >
                        <TextField
                          type="text"
                          variant="outlined"
                          fullWidth
                          placeholder={`Value ${index + 1}`}
                          required={required}
                          value={value || ""}
                          onChange={(e) => handleArrayChange(id, locale, index, e.target.value)}
                          size="small"
                          InputProps={{
                            sx: {
                              '& input::placeholder': {
                                fontSize: '0.975rem',
                              }
                            }
                          }}
                          sx={{
                            '& .MuiInputBase-input.Mui-disabled': {
                              WebkitTextFillColor: 'black',
                              color: 'black',
                            },
                          }}
                          disabled={isVersionPreview}
                        />
                        <IconButton
                          color="error"
                          onClick={() => handleArrayDelete(id, locale, index)}
                          size="small"
                          disabled={isVersionPreview}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Box>
                    ))}
                    <Button
                      startIcon={<AddIcon />}
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        const currentArray = formData[id]?.[locale] || [];
                        handleArrayChange(id, locale, currentArray.length, "");
                      }}
                      sx={{
                        mt: 1,
                      }}
                      disabled={isVersionPreview}
                    >
                      Add Value
                    </Button>
                    {renderError(id, locale)}
                  </AccordionDetails>
                </Accordion>
              ))
            ) : (
              <Accordion
                defaultExpanded
                sx={{
                  mt: 1,
                  '&:before': { display: 'none' },
                  boxShadow: 'none',
                  border: '1px solid #e0e0e0',
                  borderRadius: '4px',
                }}
              >
                <AccordionDetails>
                  {(formData[id]?.['en'] || [""]).map((value, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: 'flex',
                        gap: 1,
                        mb: 1,
                        alignItems: 'center'
                      }}
                    >
                      <TextField
                        variant="outlined"
                        value={value || ""}
                        fullWidth
                        required={required}
                        placeholder={`Value ${index + 1}`}
                        onChange={(e) => handleArrayChange(id, 'en', index, e.target.value)}
                        size="small"
                        InputProps={{
                          sx: {
                            '& input::placeholder': {
                              fontSize: '0.975rem',
                            }
                          }
                        }}
                        onKeyPress={(e) => {
                          // Allow only numbers, decimal point, and control keys
                          if (!/[\d.]|\./g.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete') {
                            e.preventDefault();
                          }
                          // Prevent multiple decimal points
                          if (e.key === '.' && value?.toString().includes('.')) {
                            e.preventDefault();
                          }
                        }}
                        sx={{
                          '& .MuiInputBase-input.Mui-disabled': {
                            WebkitTextFillColor: 'black',
                            color: 'black',
                          },
                        }}
                        disabled={isVersionPreview}
                      />
                      <IconButton
                        color="error"
                        onClick={() => handleArrayDelete(id, 'en', index)}
                        size="small"
                        disabled={isVersionPreview}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  ))}
                  <Button
                    startIcon={<AddIcon />}
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      const currentArray = formData[id]?.['en'] || [];
                      handleArrayChange(id, 'en', currentArray.length, "");
                    }}
                    sx={{ mt: 1 }}
                    disabled={isVersionPreview}
                  >
                    Add Value
                  </Button>
                  {renderError(id, 'en')}
                </AccordionDetails>
              </Accordion>
            )}

          </FormControl>
        );
      case "reference":
        return (
          <>
            {renderLabel(name, required)}
            <Box sx={{
              borderWidth: 1,
              borderColor: "#E6E6E6",
              borderStyle: "solid",
              alignItems: 'flex-start',
              p: 2,
              borderRadius: 2
            }}>
              <Box
                sx={{
                  width: '100%',
                  marginLeft: 0,
                  marginRight: 0,
                  alignItems: 'flex-start',
                  p: 1,
                  display: {
                    xs: 'block',
                    md: 'flex'
                  }
                }}
                alignItems="center"
                display={isMobile ? 'block' : "flex"}
                justifyContent="space-evenly">
                <Button
                  variant="outlined"
                  label="Add Existing Reference "
                  onClick={() => openModal(id)}
                  sx={{ width: { xs: '100%', md: '220px' } }}

                >+ Add Existing Reference</Button>
                <Typography color="secondary" align="center">or</Typography>

                <RightDrawer
                  contentTypeId={getContentTypeId()}
                  selectedRef={selectedRefs[id]}
                  setParentSelectedRef={setSelectedRefs}
                  fieldId={id}
                  editEntry={referenceEditing.isEditing && referenceEditing.fieldId === id ? referenceEditing.entryData : null}
                  isEditMode={referenceEditing.isEditing && referenceEditing.fieldId === id}
                  onEditClose={() => {
                    setReferenceEditing({
                      isEditing: false,
                      entryData: null,
                      fieldId: null
                    });
                  }}
                />
              </Box>
              {Array.isArray(selectedRefs[id]) && selectedRefs[id]?.length > 0 && (
                <Box sx={{ width: '100%' }}>
                  {selectedRefs[id]?.map((entry) => (
                    <Box
                      key={entry._id}
                      display="flex"
                      justifyContent="space-between"
                      sx={{
                        width: '100%',
                        marginBottom: 1,
                        marginTop: 1,
                        borderWidth: 1,
                        borderColor: "#E6E6E6",
                        borderStyle: "solid",
                        p: 1,
                        borderRadius: 2
                      }}>
                      <Box display="flex" alignItems="center" gap={2}>
                        <Typography variant="body1">
                          {entry.identifier}
                        </Typography>
                        <Typography
                          sx={{
                            color: entry.published ? 'green' : '#856404',
                            backgroundColor: entry.published ? '#e6ffe6' : '#fff3cd',
                            padding: '2px 8px',
                            borderRadius: '4px',
                            fontSize: 13,
                          }}
                        >
                          {entry.published ? 'Published' : 'Draft'}
                        </Typography>
                      </Box>
                      <Box>
                        <IconButton
                          onClick={() => {
                            handleEditReference(entry, id);
                          }}
                        >
                          <img
                            src={editIcon}
                            alt="edit icon"
                            style={{ width: '20px', height: '20px' }}
                          />
                        </IconButton>
                        <IconButton
                          color="secondary"
                          onClick={() => setSelectedRefs(prev => ({
                            ...prev,
                            [id]: prev[id].filter(e => e._id !== entry._id)
                          }))}
                          aria-label="delete"
                        >
                          <img
                            src={DeleteIcon}
                            alt="delete icon"
                            style={{ width: '20px', height: '20px' }}
                          />
                        </IconButton>
                      </Box>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
            {renderError(id)}

            {/* <AddReferrenceModal
              isOpen={modalOpen}
              onClose={() => {
                setModalOpen(false)
              }}
              onChange={(value) => handleRefChange(value, name)}
            /> */}
            <AddExistingEntryPopup
              open={addExistingEntryPopup.open}
              onClose={() => setAddExistingEntryPopup({ open: false, fieldId: null })}
              onConfirm={(selectedIds) => handleReferenceAddEntry(selectedIds, addExistingEntryPopup.fieldId)}
            />
          </>
        );

      default:
        return null;
    }
  };

  // useEffect(() => {
  //   console.log('SELECTED REFS : ', selectedRefs);

  // }, [selectedRefs])

  const validateField = (field, value) => {
    if (field.required) {

      if (value === undefined || value === null) {
        return 'This field is required';
      }

      switch (field.type) {
        case 'richText':
          const hasContent = (content) => {
            if (Array.isArray(content)) {
              return content.some(node =>
                node?.children?.some(child => child?.text?.trim().length > 0)
              );
            }
            if (content && typeof content === 'object') {
              return Object.values(content).some(localeContent =>
                Array.isArray(localeContent) && localeContent.some(node =>
                  node?.children?.some(child => child?.text?.trim().length > 0)
                )
              );
            }
            return false;
          };

          if (field.localizations) {
            const emptyLocales = spaceLocales.filter(locale => {
              const localeValue = value?.[locale];
              return !hasContent(localeValue);
            });

            if (emptyLocales.length > 0) {
              return emptyLocales.reduce((acc, locale) => ({
                ...acc,
                [locale]: 'This field is required'
              }), {});
            }
          } else if (!hasContent(value)) {
            return 'This field is required';
          }
          return '';

        case 'string':
          if (field.localizations) {
            const emptyStringLocales = spaceLocales.filter(locale => {
              const localeValue = value?.[locale];
              return !localeValue || (typeof localeValue === 'string' && !localeValue.trim());
            });

            if (emptyStringLocales.length > 0) {
              return emptyStringLocales.reduce((acc, locale) => ({
                ...acc,
                [locale]: 'This field is required'
              }), {});
            }
          } else {
            if (!value ||
              (typeof value === 'string' && !value.trim()) ||
              (typeof value === 'object' && (!value.en || !value.en.trim()))) {
              return 'This field is required';
            }
          }
          return '';

        case 'dateTime':
          if (!value?.date || !value?.time) {
            return 'This field is required';
          }
          return '';

        case 'array':
          if (field.array_type === 'number') {
            const enValue = value?.['en'] || [];

            if (!enValue || !Array.isArray(enValue) || enValue.length === 0) {
              return 'This field is required';
            }
            return '';
          }

          const emptyArrayLocales = spaceLocales.filter(locale => {
            const localeValue = value?.[locale];
            return !localeValue || !localeValue.some(item => item && item.trim());
          });
          if (emptyArrayLocales.length > 0) {
            return emptyArrayLocales.reduce((acc, locale) => ({
              ...acc,
              [locale]: 'This field is required'
            }), {});
          }

          return '';

        case 'reference':
          if (!value || !Array.isArray(value) || value.length === 0) {
            return 'This field is required';
          }
          return '';

        case 'boolean':
          if (value === undefined || value === null || value === '') {
            return 'This field is required';
          }
          return '';

        default:
          if (field.localizations) {
            const emptyLocales = spaceLocales.filter(locale => {
              const localeValue = value?.[locale];
              return !localeValue || (typeof localeValue === 'string' && !localeValue.trim());
            });

            if (emptyLocales.length > 0) {
              return emptyLocales.reduce((acc, locale) => ({
                ...acc,
                [locale]: 'This field is required'
              }), {});
            }
          } else {
            if (!value ||
              (typeof value === 'string' && !value.trim()) ||
              (typeof value === 'number' && isNaN(value))) {
              return 'This field is required';
            }
          }
          return '';
      }
    }
    return '';
  };

  const handleSubmit = async (e, status) => {
    if (isVersionPreview) return;
    e.preventDefault();
    const newErrors = {};
    let hasError = false;

    if (!formData.identifier?.trim()) {
      newErrors.identifier = 'Identifier is required';
      hasError = true;
    }


    console.log('Starting validation...');

    // Validate all fields
    (contentType?.contentType?.fields || data)?.forEach((field) => {
      const fieldValue = getFieldValue(field, formData[field.id]);

      // Then check required fields
      if (field.required) {
        if (field.type === 'reference') {
          if (!selectedRefs[field.id] || selectedRefs[field.id].length === 0) {
            newErrors[field.id] = 'This field is required';
            hasError = true;
          }
        } else {
          const error = validateField(field, fieldValue);
          if (error) {
            newErrors[field.id] = error;
            hasError = true;
          }
        }
      }

      if (field.type === 'array' && field.array_type === 'number') {
        const arrayValue = formData[field.id]?.['en'] || [];
        if (arrayValue.length > 0) {
          const isValidNumber = arrayValue.some(item =>
            /^-?\d+(\.\d+)?$/.test(item)
          );
          if (!isValidNumber) {
            newErrors[field.id] = 'Please enter a valid number';
            hasError = true;
            return;
          }
        }
      }

      // Check regular number field validation
      if (field.type === 'number') {
        if (fieldValue !== '' && fieldValue !== null && fieldValue !== undefined) {
          const isValidNumber = /^-?\d+(\.\d+)?$/.test(fieldValue);
          if (!isValidNumber) {
            newErrors[field.id] = 'Please enter a valid number';
            hasError = true;
          }
        }
      }
    });

    setErrors(newErrors);

    if (hasError) {
      setErrorMessage("Please fill in all required fields");
      setOpenSnackbar(true);
      setSeverity("error");
      return;
    }


    if (status === true) {
      setPublishLoading(true);
    } else {
      setPublishDraftLoading(true);
    }
    try {
      if (formRef.current.reportValidity()) {
        const referenceFields = (contentType?.contentType?.fields || data).filter(
          field => field.type === "reference"
        );

        const references = {};
        referenceFields.forEach(field => {
          if (selectedRefs[field.id]) {
            references[field.id] = selectedRefs[field.id].map(ref => ref._id);
          }
        });


        const formattedData = {
          identifier: formData.identifier,
          data: {},
          localeData: {},
          references,
          workspaceId: workspaceId,
          contentTypeId: getContentTypeId(),
          ...(isEditMode ? {} : { published: status }),
        };

        console.log('FORMATTED DATA : ', formattedData);
        
        
        (contentType?.contentType?.fields || data)?.forEach((field) => {
          const fieldValue = formData[field.id];

          if (field.type == 'string' || field.type == 'richText' || field.type == 'array') {
            spaceLocales.forEach(locale => {
              if (!formattedData.localeData[locale]) {
                formattedData.localeData[locale] = {};
              }
              if (fieldValue?.[locale]) {
                formattedData.localeData[locale][field.id] = fieldValue[locale];
              }
            });
          } else {
            if (fieldValue) {
              formattedData.data[field.id] = fieldValue;
            }
          }
        });

        try {
          if (isEditMode) {
            const entryId = isDrawerEdit ? editEntry.entry._id : entry._id;
            const response = await dispatch(updateEntryData(entryId, formattedData))
            if (response.status === "success") {
              const newEntry = {
                _id: response.entryId,
                identifier: formattedData.identifier,
                published: status,
                contentTypeId: getContentTypeId(),
                content_type_name: contentType?.contentType?.name,
                ...response.entry
              };

              setSuccessMessage("Entry Edited Successfully");
              setOpenSnackbar(true);
              setSeverity("success");
              dispatch(getEntryForEdit(workspaceId, id));
              if (onConfirm) {
                onConfirm(newEntry);
              }
            } else {
              setSuccessMessage(`Error: ${response?.message || "An error occurred"} `);
              setOpenSnackbar(true);
              setSeverity("error");
            }
          } else {
            const response = await dispatch(submitFormData(formattedData));
            if (response.status === "success") {
              const newEntry = {
                _id: response.entryId,
                identifier: formattedData.identifier,
                published: status,
                contentTypeId: getContentTypeId(),
                content_type_name: contentType?.contentType?.name,
                data: formattedData.data || {},
                localeData: formattedData.localeData || {},
                references: formattedData.references || {}
              };

              setSelectedRefs(prev => ({
                ...prev,
                [id]: [...(prev[id] || []), newEntry]
              }));

              setSuccessMessage("Entry Created");
              setOpenSnackbar(true);
              setSeverity("success");

              if (!isDrawer) {
                navigate(`/${workspaceId}/edit-entry/${response.entryId}`);
              }

              if (onConfirm) {
                onConfirm(newEntry);
              }
            } else {
              setSuccessMessage(`Error: ${response?.message || "An error occurred"} `);
              setOpenSnackbar(true);
              setSeverity("error");
            }
          }
        } catch (error) {
          setSuccessMessage(`Error: ${error.message} `);
          setOpenSnackbar(true);
          setSeverity("error");
        }
      }
    } catch (error) {
      console.log('Please Try again.');
    } finally {
      if (status === true) {
        setPublishLoading(false);
      } else {
        setPublishDraftLoading(false);
      }
    }
  };

  const handlePublishToggle = async (e) => {
    if (isVersionPreview) return;
    e.preventDefault();
    setPublishDraftLoading(true);

    try {
      const entryId = isDrawerEdit ? editEntry.entry._id : entry._id;
      const updateData = {
        identifier: formData.identifier,
        published: !isPublished,
        ...formData
      };

      const response = await dispatch(updateEntryData(entryId, updateData));

      if (response.status === "success") {
        setIsPublished(!isPublished);
        setSuccessMessage(`Entry ${!isPublished ? 'Published' : 'Unpublished'} Successfully`);
        setOpenSnackbar(true);
        setSeverity("success");

        if (onConfirm) {
          const updatedEntry = {
            ...editEntry.entry,
            published: !isPublished
          };

          if (referenceEditing.fieldId) {
            setSelectedRefs(prev => ({
              ...prev,
              [referenceEditing.fieldId]: prev[referenceEditing.fieldId].map(ref =>
                ref._id === updatedEntry._id ? { ...ref, published: !isPublished } : ref
              )
            }));
          }

          onConfirm(updatedEntry);
        }
      }
    } catch (error) {
      setErrorMessage(error.message);
      setOpenSnackbar(true);
      setSeverity("error");
    } finally {
      setPublishDraftLoading(false);
    }
  };

  // useEffect(() => {
  //   if (Object.keys(selectedRefs).length > 0) {
  //     Object.entries(selectedRefs).forEach(([fieldId, refs]) => {
  //       if (refs?.length > 0) {
  //         setErrors(prev => ({
  //           ...prev,
  //           [fieldId]: ''
  //         }
  //         ))
  //       }
  //     }
  //     )
  //   }
  // })

  const isFieldValid = (field, value) => {
    if (!value) return false;

    switch (field.type) {
      case 'string':
      case 'richText':
        if (field.localizations) {
          return Object.values(value).some(v => v && v.length > 0);
        }
        return typeof value === 'string' && value.trim().length > 0;

      case 'number':
        return value !== null && value !== undefined && !isNaN(value);

      case 'dateTime':
        return value?.date && value?.time;

      case 'boolean':
        return value === true || value === false;

      case 'media':
        return Array.isArray(value) && value.length > 0;

      case 'array':
        return Array.isArray(value) && value.length > 0;

      case 'reference':
        return Array.isArray(value) && value.length > 0;

      default:
        return !!value;
    }
  };


  const handleChange = (id, value, locale) => {
    if (id === 'identifier') {
      setFormData(prev => ({
        ...prev,
        identifier: value
      }));

      if (value?.trim()) {
        setErrors(prev => ({
          ...prev,
          identifier: ''
        }));
      }
      return;
    }

    const field = (contentType?.contentType?.fields || data)?.find(f => f.id === id);
    if (field?.localizations && locale) {
      setModifiedLocaleFields(prev => ({
        ...prev,
        [id]: {
          ...(prev[id] || {}),
          [locale]: true
        }
      }));

      setFormData(prev => ({
        ...prev,
        [id]: {
          ...(prev[id] || {}),
          [locale]: value
        }
      }));
    } else {
      setModifiedFields(prev => ({
        ...prev,
        [id]: true
      }));

      let newValue;
      switch (field?.type) {
        case 'string':
          if (locale) {
            newValue = {
              ...formData[id],
              [locale]: value
            };
          } else {
            newValue = {
              ...(formData[id] || {}),
              en: value
            };
          }
          break;

        case 'richText':
          newValue = locale ? {
            ...formData[id],
            [locale]: value
          } : value;
          break;

        case 'boolean':
          newValue = value;
          break;

        default:
          newValue = locale ? {
            ...formData[id],
            [locale]: value
          } : value;
      }

      setFormData(prev => ({
        ...prev,
        [id]: newValue
      }));
    }

    // Clear errors if field is required and has value
    if (field?.required) {
      if (field.localizations) {
        if (value?.trim?.()) {
          setErrors(prev => ({
            ...prev,
            [id]: {
              ...(prev[id] || {}),
              [locale]: ''
            }
          }));
        }
      } else if (value) {
        setErrors(prev => ({
          ...prev,
          [id]: ''
        }));
      }
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
    setErrorMessage("");
  };

  return (
    <div>
      <div>
        <div className="md:flex justify-between md:mx-12">
          <div className="flex items-start gap-4 md:flex-wrap ml-8 md:ml-0">
            <img src={BrushImage} alt="Brush" className="w-8 md:w-10 h-8 md-10" style={{ width: isMobile ? 32 : 40, height: isMobile ? 32 : 40 }} />
            <h1 className="text-2xl md:text-4xl font-bold">
              {isEditMode ? (
                <span>
                  Edit Entry <span className="font-normal">
                    "{(isEditMode && editEntry) ? editEntry.entry.identifier : entry?.identifier}"
                  </span>
                </span>
              ) : (

                <span>
                  Create Entry{" "}
                  <span className="font-normal">"{contentType?.contentType?.name || entryName}"</span>
                </span>
              )}
            </h1>

          </div>
          <div className="space-x-3 max-md:mt-4">
            {!versionPanelOpen && !isVersionPreview && (
              isEditMode ? (
                <>
                  <div>
                    <ButtonGroup variant="contained" sx={{
                      borderRadius: "32px",
                      overflow: "hidden",

                    }}>
                      <Button style={{ padding: "10px 32px", background: 'linear-gradient(312deg, rgba(62,142,255,1) 0%, rgba(36,93,173,1) 35%)' }} startIcon={publishLoading ? (<LoadingSpinner />) : (<img src={SaveDraftIcon} alt="save icon" style={{ width: 20, height: 20, marginTop: 1 }} />)}
                        type="submit"
                        label={publishLoading ? "Saving..." : "Save"}
                        onClick={(e) => handleSubmit(e, true)}
                        disabled={publishLoading || !hasPermission('editor')}
                        sx={{
                          '&.Mui-disabled': {
                            backgroundColor: 'primary.main',
                            color: 'white',
                            opacity: 0.7,

                          }
                        }}
                      >Save
                      </Button>

                      <Button
                        size="small"
                        onClick={handleDropdownClick}
                      >
                        <ArrowDropDownIcon />
                      </Button>
                    </ButtonGroup>

                    <Menu
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <MenuItem
                        onClick={handlePublishToggle}
                        disabled={publishDraftLoading || !hasPermission('editor')}
                        sx={{
                          '&.Mui-disabled': {
                            backgroundColor: 'white',
                            color: 'primary.main',
                            opacity: 0.7,
                          },
                        }}
                      >
                        {
                          publishDraftLoading ? (
                            <LoadingSpinner color="white" sx={{ marginRight: 1 }} />
                          ) : (
                            <img
                              src={CloudIcon}
                              alt="Status Toggle Icon"
                              style={{ width: 24, height: 24, marginRight: 1, color: 'primary.main' }}
                            />
                          )
                        }

                        {
                          publishDraftLoading
                            ? "Processing..."
                            : isPublished
                              ? "Unpublish"
                              : "Publish"
                        }
                      </MenuItem>
                      <Divider />
                      <MenuItem
                        onClick={() => setVersionPanelOpen(!versionPanelOpen)}
                        disabled={!hasPermission('editor')}
                      >
                        <HistoryIcon sx={{ marginRight: 1 }} />
                        Version Control
                      </MenuItem>


                    </Menu>
                  </div>
                  {/* <OutlinedAddButton
                    startIcon={<HistoryIcon />}
                    label="Version Control"
                    onClick={() => setVersionPanelOpen(!versionPanelOpen)}
                    disabled={!hasPermission('editor')}
                  />
                  <OutlinedAddButton
                    startIcon={
                      publishDraftLoading ? (
                        <LoadingSpinner color='white' />
                      ) : (
                        <img src={SaveDraftIcon} alt="Status Toggle Icon" style={{ width: 24, height: 24 }} />
                      )
                    }
                    label={publishDraftLoading
                      ? "Processing..."
                      : isPublished
                        ? "Unpublish"
                        : "Publish"
                    }
                    onClick={handlePublishToggle}
                    disabled={publishDraftLoading || !hasPermission('editor')}
                    sx={{
                      '&.Mui-disabled': {
                        backgroundColor: 'white',
                        color: 'primary.main',
                        opacity: 0.7
                      }
                    }}
                  />

                  <AddButton
                    startIcon={
                      publishLoading ? (
                        <LoadingSpinner />
                      ) : (
                        <img src={CloudIcon} alt="save icon" style={{ width: 24, height: 24, marginTop: 1 }} />
                      )
                    }
                    type="submit"
                    label={publishLoading ? "Saving..." : "Save"}
                    onClick={(e) => handleSubmit(e, true)}
                    disabled={publishLoading || !hasPermission('editor')}
                    sx={{
                      '&.Mui-disabled': {
                        backgroundColor: 'primary.main',
                        color: 'white',
                        opacity: 0.7
                      }
                    }}
                  /> */}
                </>
              ) : (
                <>
                  <OutlinedAddButton
                    startIcon={
                      publishDraftLoading ? (
                        <LoadingSpinner color='primary.main' />
                      ) : (
                        <img src={SaveDraftIcon2} alt="Save Draft Icon" style={{ width: 24, height: 24 }} />
                      )
                    }
                    variant="outlined"
                    label={publishDraftLoading ? "Saving Draft..." : "Save Draft"}
                    onClick={(e) => handleSubmit(e, false)}
                    disabled={publishDraftLoading}
                    sx={{
                      '&.Mui-disabled': {
                        backgroundColor: 'white',
                        color: 'primary.main',
                        opacity: 0.7
                      }
                    }}
                  />

                  <AddButton
                    startIcon={
                      publishLoading ? (
                        <LoadingSpinner />
                      ) : (
                        <img src={CloudIcon2} alt="cloud icon" style={{ width: 24, height: 24, marginTop: 1 }} />
                      )
                    }
                    type="submit"
                    label={publishLoading ? "Publishing..." : "Publish"}
                    onClick={(e) => handleSubmit(e, true)}
                    disabled={publishLoading}
                    sx={{
                      '&.Mui-disabled': {
                        backgroundColor: 'primary.main',
                        color: 'white',
                        opacity: 0.7
                      }
                    }}
                  />
                </>
              )
            )}
          </div>
        </div>
        <div className="mt-10">
          <form className="max-w-4xl mx-auto p-3" ref={formRef}>
            <div className="grid grid-cols-1 gap-2 mt-2">
              <FormControl fullWidth variant="outlined" component="fieldset" style={{ marginTop: "10px" }}>
                {renderLabel('Identifier', true)}
                <TextField
                  key="identifier"
                  type="text"
                  variant="outlined"
                  fullWidth
                  value={formData.identifier}
                  onChange={(e) => handleChange("identifier", e.target.value)}
                  sx={{
                    '& .MuiInputBase-root': {
                      paddingY: '4px',
                    },

                    '& .MuiInputBase-input': {
                      padding: '6px',
                      paddingY: '4px',
                      lineHeight: 1.5,
                    },
                    '& .MuiInputLabel-root': {
                      top: '-8px',
                      fontSize: '16px',
                      color: '#7A7A7A',
                    },
                    '& .MuiInputBase-input.Mui-disabled': {
                      WebkitTextFillColor: 'black',
                      color: 'black',
                    },
                  }}
                  disabled={isVersionPreview}
                />
                {renderError("identifier")}
              </FormControl>
              {(contentType?.contentType?.fields || data)?.map((field) => (
                <div key={field.id}>
                  {renderInput(field)}
                </div>
              ))}
            </div>

          </form>
        </div>
      </div>
      {!isVersionPreview && (
        <VersionDrawer
          open={versionPanelOpen}
          onClose={(e) => handleDrawerClose(e)}
          entry={entrySelector}
          contentType={data}
          onVersionSelect={(versionData) => {
            const timestamp = Date.now();
            setFormData({
              ...versionData,
              identifier: formData.identifier,
              _versionKey: timestamp
            });
          }}
        />
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={severity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {severity === "success" ? successMessage : errorMessage}
        </Alert>
      </Snackbar>
      {!isInitialized && !isCreateMode &&
        <LoadingOverlay />}

      {loading && <LoadingOverlay />}
    </div>
  );
};

export default CreateEntry;
